import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import type { IxcFundingV1AccountNumberQueryServiceAccountNumberListSearchableFields } from '@interxfi/types/generated/api';
import { PageTabRail } from '../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { FundingAccountNumberCreateDrawer } from '../../../../../../features/funding/account-number/funding-account-number-create-drawer';
import {
  type FundingAccountNumberFilterableField,
  FundingAccountNumbersTable,
} from '../../../../../../features/funding/account-number/funding-account-numbers-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/funding/account-number/_account-number/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RollupFunding,
      label: 'Account Numbers',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RollupFunding>,
  head: () => getPageHead('Account Numbers'),
  component: FundingAccountNumberList,
});

function TableHeader({
  filter,
}: CustomTableHeaderProps<FundingAccountNumberFilterableField, IxcFundingV1AccountNumberQueryServiceAccountNumberListSearchableFields>) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <FundingAccountNumberCreateDrawer
              trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Account Number" size="small" />}
            />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RollupFunding}
    />
  );
}

function FundingAccountNumberList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FundingAccountNumbersTable HeaderActions={TableHeader} viewContext={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
